/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-danger[_ngcontent-%COMP%]{background-color:#b62027;font-family:Montserrat-Light,sans-serif;font-size:.9rem}.modal-body[_ngcontent-%COMP%]{font-family:Montserrat-Light,sans-serif}.modal-title[_ngcontent-%COMP%]{font-family:Montserrat-Regular,sans-serif}.font-color[_ngcontent-%COMP%]{color:#000}\n/*# sourceMappingURL=confirmation-modal.component.css.map*/"];
export { styles as styles };
